
    /**
     * Переключатель повседневных одежд, размер
     */
    eventClick('.every-day-clothes', function (data) {

        $('.every-day-clothes-table:not([data-id="' + data.data('id') + '"])').hide();

        $('.every-day-clothes-table[data-id="' + data.data('id') + '"]').show();

        $('.every-day-clothes:not([data-id="' + data.data('id') + '"])').removeClass('active');

        data.addClass('active');

        if (data.data('id') === 1){

            $('.categories').show();
            $('.every-day-clothes-table[data-item="1"]').show();
            $('.every-day-clothes-table[data-item="2"]').hide();
            $('.every-day-clothes[data-item="1"]').addClass('active');
            $('.every-day-clothes-item[data-item="1"]').addClass('active');
            $('.every-day-clothes-item[data-item="2"]').removeClass('active');

        } else {

            $('.categories').hide();

        }
    })

    /**
     * Переключатель джинсов, размер
     */
    eventClick('.jeans-size', function (data) {

        $('.jeans-size-table:not([data-id="' + data.data('id') + '"])').hide();

        $('.jeans-size-table[data-id="' + data.data('id') + '"]').show();

        $('.jeans-size:not([data-id="' + data.data('id') + '"])').removeClass('active');

        data.addClass('active');

    })

    /**
     * Переключатель джинсов, размер
     */
    eventClick('.shoes-size', function (data) {

        $('.shoes-size-table:not([data-id="' + data.data('id') + '"])').hide();

        $('.shoes-size-table[data-id="' + data.data('id') + '"]').show();

        $('.shoes-size:not([data-id="' + data.data('id') + '"])').removeClass('active');

        data.addClass('active');

    })

    /**
     * Переключатель между подкатегориями (Одежда бюстгальтеры)
     */
    eventClick('.every-day-clothes-item', function (data){

        $('.every-day-clothes-table:not([data-item="' + data.data('item') + '"])').hide();
        $('.every-day-clothes-table[data-item="' + data.data('item') + '"]').show();

        $('.every-day-clothes-item:not([data-item="' + data.data('item') + '"])').removeClass('active');
        $(data).addClass('active');


    })
